/* eslint-disable react/no-danger */
import React from 'react'
import classNames from 'classnames'
import classes from '@src/styles/disposal/highlight.module.css'

export type HighlightProps = {
  heading: string
  /** Path/URL of the photo shown alongside the copy. */
  image: string
  imageAlt: string
  /** Blocks of copy. Each may carry inline markup or a whole list. */
  content: string[]
  /** Puts the photo on the left instead of the right. */
  imageFirst?: boolean
  className?: string
}

/**
 * A single band of copy next to one photo — the port of the app repo's
 * one-entry FAQ block, which is how the Austin page shipped its Universal
 * Recycling Ordinance explainer. Use it for a standalone piece of page content
 * that is not a Q&A and not a feature list; <FAQ> is the multi-entry sibling.
 *
 * `content` entries are rendered as raw HTML (matching <FAQ> and <FeatureList>),
 * so a block can be a paragraph or an `<ol>`/`<ul>` — list styling for both
 * lives in the CSS module.
 */
function Highlight({ heading, image, imageAlt, content, imageFirst, className }: HighlightProps) {
  return (
    <section className={className}>
      <div className={classes.container}>
        <div className={classNames(classes.band, imageFirst && classes.bandImageFirst)}>
          <div className={classes.copy}>
            <h2 className={classes.heading} dangerouslySetInnerHTML={{ __html: heading }} />
            {content.map((block) => (
              <div
                key={block}
                className={classes.block}
                dangerouslySetInnerHTML={{ __html: block }}
              />
            ))}
          </div>
          <img className={classes.image} src={image} alt={imageAlt} />
        </div>
      </div>
    </section>
  )
}

export default Highlight
